import { Route, Routes } from 'react-router-dom'
import AssignAssetPage from './Page'
// import AssignAssetFormIndex from './Form'

export default function AssignAsset() {
  return (
    <Routes>
        <Route path="/" element={<AssignAssetPage />} />
        <Route path="/:id" element={<AssignAssetPage />} />
        <Route path="/:id/assign" element={<AssignAssetPage />} />
        <Route path="/:id/logs" element={<AssignAssetPage />} />
        <Route path="/:id/transfer" element={<AssignAssetPage />} />
    </Routes>
  )
}
